import React from 'react'
import OpenLeads from './openLeads'

// Export Leads reuses the Open Leads list in "export mode":
// it lists leads flagged exportLead:true and swaps the bulk action
// to "Remove from Export Leads".
const ExportLeads = (props) => <OpenLeads {...props} exportMode={true} />

export default ExportLeads
